export default class Picture {
  constructor(data) {
    this.id = data.imageId || data.id;
    this.url = data.url;
    this.sort = +data.sort;
    this.isCover = +data.sort === 0;
    this.isMedia = data.url && data.url.indexOf('.mp4') >= 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/picture.model.js